import React from 'react'

import { LoaderPoints } from 'shared/ui/LoaderPoints'

export const fallback = <LoaderPoints />
